<template>
	<div>
		<Breadcrumbs main="Work Management" title="Generate Device Certificate" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
	
								<div class="row mb-3">
									<div class="col-12">
										<a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									</div>
								</div>
	
								<form  @submit.prevent="generateCertificate" enctype="multipart/form-data">
									<div class="form theme-form">

										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Product<span class="text-danger">*</span></label>
													<select class="form-select" v-model="product_id" v-bind:class="{ 'is-invalid': Boolean(errors.product_id) }">
														<option value="">Select</option>
														<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
													</select>
													<span class="validate-error" v-if="errors.product_id">
														{{ errors.product_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Dealer<span class="text-danger">*</span></label>
													<div class="position-relative dealer-dropdown">
														<input class="form-control" type="text" placeholder="Search Dealer" v-model="dealer_search" @input="handleDealerSearch" @focus="showDealerSuggestions = true" @blur="handleDealerInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.dealer_id) }"/>
														<ul
															v-if="showDealerSuggestions && filteredDealerList.length" class="list-group position-absolute"
															style="width:100%; z-index: 9999; max-height: 200px; overflow-y: auto;"
															ref="dealerSuggestionList"
														>
															<li v-for="dealer in filteredDealerList" :key="dealer.id" class="list-group-item list-group-item-action" @mousedown.prevent="setDealer(dealer)">
																{{ dealer.first_name }}
															</li>
														</ul>
													</div>
													<span class="validate-error" v-if="errors.dealer_id">
														{{ errors.dealer_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="product_id == 1">
												<div>
													<label class="control-label">Select IMEI<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No" v-model="device_imei" @input="handleImeiInput" @focus="showSuggestions = true" @blur="handleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.device_id) }"/>
													<ul
														v-if="showSuggestions && devices.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														@scroll="handleScroll" ref="suggestionList"
													>
														<li v-for="device in devices" :key="device.imei" class="list-group-item list-group-item-action" @mousedown.prevent="setImei(device)">
															{{ device.vehicle_no + ' - ' + device.imei }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.device_id">
														{{ errors.device_id[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Select RTO<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search RTO" v-model="rto_search" @input="handleRtoSearch" @focus="showRtoSuggestions = true" @blur="handleRtoInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }"/>
													<ul
														v-if="showRtoSuggestions && filteredRtoList.length" class="list-group position-absolute"
														style="width:93%; z-index: 9999; max-height: 200px; overflow-y: auto;"
														ref="rtoSuggestionList"
													>
														<li v-for="rto in filteredRtoList" :key="rto.id" class="list-group-item list-group-item-action" @mousedown.prevent="setRto(rto)">
															{{ rto.rto_code }} - {{ rto.rto_name }}
														</li>
													</ul>
													<span class="validate-error" v-if="errors.rto_id">
														{{ errors.rto_id[0] }}
													</span>
												</div>
											</div>

								
										</div>

										<div class="row">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Customer Name</label>
													<input class="form-control" type="text" placeholder="Enter Customer Name" v-model="customer_name" v-bind:class="{ 'is-invalid': Boolean(errors.customer_name) }"/>
													<span class="validate-error" v-if="errors.customer_name">
														{{ errors.customer_name[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Mobile No.<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="Enter Customer Mobile" v-model="mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" @input="restrictMobileInput"/>
												<span class="validate-error" v-if="errors.mobile">
													{{ errors.mobile[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle Type</label>
													<select class="form-select" v-model="vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }">
														<option value="">Select Vehicle Type</option>
														<option v-for="type in vehicle_types" :value="type.id">{{ type.name }}</option>
													</select>
												<span class="validate-error" v-if="errors.vehicle_type">
													{{ errors.vehicle_type[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle No.<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="Enter Vehicle Number" v-model="vehicle_no" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_no) }"/>
												<span class="validate-error" v-if="errors.vehicle_no">
													{{ errors.vehicle_no[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Engine Number</label>
												<input class="form-control" type="text" placeholder="Enter Engine Number" v-model="engine_no" v-bind:class="{ 'is-invalid': Boolean(errors.engine_no) }"/>
												<span class="validate-error" v-if="errors.engine_no">
													{{ errors.engine_no[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Chassis Number</label>
												<input class="form-control" type="text" placeholder="Enter Chassis Number" v-model="chassis_no" v-bind:class="{ 'is-invalid': Boolean(errors.chassis_no) }"/>
												<span class="validate-error" v-if="errors.chassis_no">
													{{ errors.chassis_no[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle Make</label>
												<input class="form-control" type="text" placeholder="Enter vehicle make" v-model="vehicle_make" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_make) }"/>
												<span class="validate-error" v-if="errors.vehicle_make">
													{{ errors.vehicle_make[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Vehicle Model</label>
												<input class="form-control" type="text" placeholder="Enter vehicle model" v-model="vehicle_model" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_model) }"/>
												<span class="validate-error" v-if="errors.vehicle_model">
													{{ errors.vehicle_model[0] }}
												</span>
											</div>

											<div class="col-md-3 form-group mt-2">
												<label class="control-label">Registration Date</label>
												<input class="form-control" type="date" v-model="registration_date" v-bind:class="{ 'is-invalid': Boolean(errors.registration_date) }"/>
												<span class="validate-error" v-if="errors.registration_date">
													{{ errors.registration_date[0] }}
												</span>
											</div>

											<div class="col-md-12 mt-2">
												<div class="mb-3">
													<label class="control-label">Location<span class="text-danger">*</span></label>

													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="job.location"
														v-bind:class="{ 'is-invalid': Boolean(errors.location) }">
													</GMapAutocomplete>

													<GMapMap v-if="job.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
																:position="marker.position"
																:clickable="true"
																:draggable="true"
																@drag="handleMarkerDrag"
																@click="panToMarker"
															/>
													</GMapMap > 

													<!-- <input class="form-control" type="text" placeholder="Search the location here..." v-model="location"/> -->
													<span class="validate-error" v-if="errors.location">
														{{ errors.location[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lat" disabled v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"/>
													<span class="validate-error" v-if="errors.latitude">
														{{ errors.latitude[0] }}
													</span>
												</div>
											</div>
											<div class="col-md-6">
												<div class="mb-3">
													<label class="control-label">Longitude<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="marker.position.lng" disabled v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"/>
													<span class="validate-error" v-if="errors.longitude">
														{{ errors.longitude[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Amount<span class="text-danger">*</span></label>
													<input class="form-control" type="number" placeholder="Enter Amount" v-model="amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"/>
													<span class="validate-error" v-if="errors.amount">
														{{ errors.amount[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Date<span class="text-danger">*</span></label>
													<input class="form-control" type="date" placeholder="" v-model="date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }" :max="max"/>
													<span class="validate-error" v-if="errors.date">
														{{ errors.date[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Payment Type<span class="text-danger">*</span></label>
													<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange" v-bind:class="{ 'is-invalid': Boolean(errors.payment_type) }">
														<option value="">--Select--</option>
														<option value="1">Cash</option>
														<option value="2">Online</option>
														<option value="3">Both (Cash + Online)</option>
													</select>
													<span class="validate-error" v-if="errors.payment_type">
														{{ errors.payment_type[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Company Title<span class="text-danger">*</span></label>
													<div class="position-relative company-title-dropdown">
														<input class="form-control" type="text" placeholder="Search Company Title" v-model="company_title_search" @input="handleCompanyTitleSearch" @focus="showCompanyTitleSuggestions = true" @blur="handleCompanyTitleInputBlur" v-bind:class="{ 'is-invalid': Boolean(errors.company_title_id) }"/>
														<ul
															v-if="showCompanyTitleSuggestions && filteredCompanyTitles.length" class="list-group position-absolute"
															style="width:100%; z-index: 9999; max-height: 200px; overflow-y: auto;"
															ref="companyTitleSuggestionList"
														>
															<li v-for="companyTitle in filteredCompanyTitles" :key="companyTitle.id" class="list-group-item list-group-item-action" @mousedown.prevent="setCompanyTitle(companyTitle)">
																{{ companyTitle.title }}
															</li>
														</ul>
													</div>
													<small v-if="selectedCompanyTitle" class="text-success">
														<i class="bx bx-check-circle me-1"></i>Selected: {{ selectedCompanyTitle.title }}
													</small>
													<span class="validate-error" v-if="errors.company_title_id">
														{{ errors.company_title_id[0] }}
													</span>
												</div>
											</div>

										</div>

										<!-- Payment Details Row -->
										<div class="row" v-if="payment_type">
											<div class="col-md-12 mb-3">
												<h6 class="text-primary">Payment Details</h6>
											</div>
											
											<div class="col-md-3" v-if="payment_type == 1 || payment_type == 3">
												<div class="mb-3">
													<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
													<input class="form-control" type="number" placeholder="Enter cash amount" v-model="cash_amount" min="0" step="0.01" v-bind:class="{ 'is-invalid': Boolean(errors.cash_amount) }"/>
													<span class="validate-error" v-if="errors.cash_amount">
														{{ errors.cash_amount[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="payment_type == 2 || payment_type == 3">
												<div class="mb-3">
													<label class="control-label">Online Amount<span class="text-danger">*</span></label>
													<input class="form-control" type="number" placeholder="Enter online amount" v-model="online_amount" min="0" step="0.01" v-bind:class="{ 'is-invalid': Boolean(errors.online_amount) }"/>
													<span class="validate-error" v-if="errors.online_amount">
														{{ errors.online_amount[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="payment_type == 2 || payment_type == 3">
												<div class="mb-3">
													<label class="control-label">Payment ID<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id" v-bind:class="{ 'is-invalid': Boolean(errors.payment_id) }"/>
													<span class="validate-error" v-if="errors.payment_id">
														{{ errors.payment_id[0] }}
													</span>
												</div>
											</div>
										</div>

										<!-- Product ID 2 Fields (Camera) -->
										<div class="row" v-if="product_id == 2">
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Camera Name<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter camera name" v-model="camera_name" v-bind:class="{ 'is-invalid': Boolean(errors.camera_name) }"/>
													<span class="validate-error" v-if="errors.camera_name">
														{{ errors.camera_name[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Serial Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter serial number" v-model="serial_number" v-bind:class="{ 'is-invalid': Boolean(errors.serial_number) }"/>
													<span class="validate-error" v-if="errors.serial_number">
														{{ errors.serial_number[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Camera 2</label>
													<input class="form-control" type="text" placeholder="Enter camera 2 name/serial" v-model="camera_2" v-bind:class="{ 'is-invalid': Boolean(errors.camera_2) }"/>
													<span class="validate-error" v-if="errors.camera_2">
														{{ errors.camera_2[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Camera 3</label>
													<input class="form-control" type="text" placeholder="Enter camera 3 name/serial" v-model="camera_3" v-bind:class="{ 'is-invalid': Boolean(errors.camera_3) }"/>
													<span class="validate-error" v-if="errors.camera_3">
														{{ errors.camera_3[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Camera 4</label>
													<input class="form-control" type="text" placeholder="Enter camera 4 name/serial" v-model="camera_4" v-bind:class="{ 'is-invalid': Boolean(errors.camera_4) }"/>
													<span class="validate-error" v-if="errors.camera_4">
														{{ errors.camera_4[0] }}
													</span>
												</div>
											</div>
										</div>

										<!-- Product ID 3 Fields (Speed Governor) -->
										<div class="row" v-if="product_id == 3">
											<div class="col-md-12 mb-3">
												<h6 class="text-primary">Speed Governor Details</h6>
											</div>
											
											<div class="col-md-12 form-group mb-3">
												<label class="control-label">Speed Governor<span class="text-danger">*</span></label>
												<div class="position-relative speed-governor-dropdown">
													<input 
														type="text" 
														class="form-control" 
														v-model="speedGovernorSearch"
														@click="handleSpeedGovernorClick"
														@input="filterSpeedGovernors"
														@focus="handleSpeedGovernorClick"
														placeholder="Search speed governor..."
														v-bind:class="{ 'is-invalid': Boolean(errors.sg_model || errors.sg_vehicle_model || errors.sg_cop_number) }"
													/>
													<div v-if="showSpeedGovernorDropdown" class="dropdown-menu show w-100" style="max-height: 300px; overflow-y: auto;">
														<div v-if="isLoadingSpeedGovernors" class="dropdown-item text-center">
															<i class="bx bx-loader-alt bx-spin"></i> Loading...
														</div>
														<div v-else-if="filteredSpeedGovernors.length === 0" class="dropdown-item text-muted">
															No speed governors found
														</div>
														<div 
															v-else
															v-for="sg in filteredSpeedGovernors" 
															:key="sg.id"
															class="dropdown-item cursor-pointer"
															@click="selectSpeedGovernor(sg)"
														>
															<div class="fw-bold">{{ sg.vehicle_model }}</div>
															<div v-if="sg.sg_model" class="text-muted small">{{ sg.sg_model }}</div>
														</div>
													</div>
												</div>
												<div v-if="selectedSpeedGovernor" class="mt-2">
													<small class="text-success">
														Selected: {{ selectedSpeedGovernor.vehicle_model }}
														<span v-if="selectedSpeedGovernor.sg_model"> - {{ selectedSpeedGovernor.sg_model }}</span>
													</small>
												</div>
												<span class="validate-error" v-if="errors.sg_model || errors.sg_vehicle_model">
													{{ errors.sg_model?.[0] || errors.sg_vehicle_model?.[0] }}
												</span>
											</div>

											<!-- Speed Governor Details Fields (editable) -->
											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">SG Model<span class="text-danger">*</span></label>
													<input class="form-control" type="text" v-model="sg_model" placeholder="Enter SG model" v-bind:class="{ 'is-invalid': Boolean(errors.sg_model) }"/>
													<small v-if="selectedSpeedGovernor && sg_model" class="text-muted">Auto-filled from selection</small>
													<span class="validate-error" v-if="errors.sg_model">
														{{ errors.sg_model[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">SG Vehicle Model<span class="text-danger">*</span></label>
													<input class="form-control" type="text" v-model="sg_vehicle_model" placeholder="Enter SG vehicle model" v-bind:class="{ 'is-invalid': Boolean(errors.sg_vehicle_model) }"/>
													<small v-if="selectedSpeedGovernor && sg_vehicle_model" class="text-muted">Auto-filled from selection</small>
													<span class="validate-error" v-if="errors.sg_vehicle_model">
														{{ errors.sg_vehicle_model[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">SG Test Report No</label>
													<input class="form-control" type="text" v-model="sg_test_report_no" placeholder="Enter test report number" v-bind:class="{ 'is-invalid': Boolean(errors.sg_test_report_no) }"/>
													<small v-if="selectedSpeedGovernor && sg_test_report_no" class="text-muted">Auto-filled from selection</small>
													<span class="validate-error" v-if="errors.sg_test_report_no">
														{{ errors.sg_test_report_no[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">SG TAC Number</label>
													<input class="form-control" type="text" v-model="sg_tac_number" placeholder="Enter TAC number" v-bind:class="{ 'is-invalid': Boolean(errors.sg_tac_number) }"/>
													<small v-if="selectedSpeedGovernor && sg_tac_number" class="text-muted">Auto-filled from selection</small>
													<span class="validate-error" v-if="errors.sg_tac_number">
														{{ errors.sg_tac_number[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">SG COP Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" v-model="sg_cop_number" placeholder="Enter COP number" v-bind:class="{ 'is-invalid': Boolean(errors.sg_cop_number) }"/>
													<small v-if="selectedSpeedGovernor && sg_cop_number" class="text-muted">Auto-filled from selection</small>
													<span class="validate-error" v-if="errors.sg_cop_number">
														{{ errors.sg_cop_number[0] }}
													</span>
												</div>
											</div>
										</div>

										<div class="row">

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">RC Image<span class="text-danger">*</span></label>
													<input ref="rcImageInput" type="file" @change="setFile($event, 'rc_image')" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.rc_image) }"/>
													<span class="validate-error" v-if="errors.rc_image">
														{{ errors.rc_image[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Device Image<span class="text-danger">*</span></label>
													<input ref="deviceImageInput" type="file" @change="setFile($event, 'device_image')" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.device_image) }"/>
													<span class="validate-error" v-if="errors.device_image">
														{{ errors.device_image[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Vehicle Image<span class="text-danger">*</span></label>
													<input ref="vehicleImageInput" type="file" @change="setFile($event, 'vehicle_image')" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_image) }"/>
													<span class="validate-error" v-if="errors.vehicle_image">
														{{ errors.vehicle_image[0] }}
													</span>
												</div>
											</div>

											<div class="col-md-3" v-if="product_id == 2">
												<div class="mb-3">
													<label class="control-label">Captured Image<span class="text-danger">*</span></label>
													<input ref="capturedImageInput" type="file" @change="setFile($event, 'captured_images')" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.captured_images) }"/>
													<span class="validate-error" v-if="errors.captured_images">
														{{ errors.captured_images[0] }}
													</span>
												</div>
											</div>

										</div>

										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="isSubmitting">
													<span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ isSubmitting ? 'Saving...' : 'Save' }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>

						</div>
					</div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
	import Swal from '@/utils/swal';
	import { get, post } from '@/utils/api';
	import { routes } from '@/constants/routes';
	import { onMounted, onUnmounted, ref, getCurrentInstance, computed, watch } from 'vue';
	import { useRouter } from 'vue-router';
	import { debounce } from 'lodash';
	import { goBack } from '@/utils/urlHider';

	// Get today's date in local timezone (IST)
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	// Format date as YYYY-MM-DD for date input using local timezone
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	const todayFormatted = `${year}-${month}-${day}`;
	const date = ref(todayFormatted);

	const min = date.value;
	const max = todayFormatted;
	
 	const { proxy } = getCurrentInstance();
	const fetchDevicesDebounced = debounce(() => fetchDevices(), 300);
	const fetchAllDevicesDebounced = debounce(() => fetchAllDevicesForSearch(), 300);
	const router = useRouter();
	const products = ref([]);
	const product_id = ref("");
	const mobile = ref("");
	const customer_name = ref("");
	const work_type = ref("");
	const dealer_id = ref("");
	const dealers = ref([]);
	const vehicle_no = ref("");
	const engine_no = ref("");
	const chassis_no = ref("");
	const vehicle_make = ref("");
	const vehicle_model = ref("");
	const registration_date = ref("");
	const location = ref("");
	const latitude = ref("");
	const longitude = ref("");
	const amount = ref("");
	const isSubmitting = ref(false);
	const rc_image = ref(null);
	const device_image = ref(null);
	const vehicle_image = ref(null);
	const captured_images = ref(null);
	const device_imei = ref("");
	const camera_name = ref("");
	const camera_2 = ref("");
	const camera_3 = ref("");
	const camera_4 = ref("");
	const serial_number = ref("");
	const payment_type = ref("");
	const payment_id = ref("");
	const online_amount = ref("");
	const cash_amount = ref("");
	const selectedCompanyTitle = ref(null);
	const company_titles = ref([]);
	const company_title_search = ref("");
	const filteredCompanyTitles = ref([]);
	const showCompanyTitleSuggestions = ref(false);
	const companyTitleSuggestionList = ref(null);
	const sg_model = ref("");
	const sg_vehicle_model = ref("");
	const sg_test_report_no = ref("");
	const sg_tac_number = ref("");
	const sg_cop_number = ref("");
	// Speed Governor related variables
	const speedGovernors = ref([]);
	const filteredSpeedGovernors = ref([]);
	const speedGovernorSearch = ref('');
	const selectedSpeedGovernor = ref(null);
	const showSpeedGovernorDropdown = ref(false);
	const isLoadingSpeedGovernors = ref(false);
	const vehicle_search = ref(""); // New variable for vehicle search field
	const devices = ref([]);
	const showSuggestions = ref(false);
	const device_id = ref("");
	const vehicle_types = ref([]);
	const vehicle_type = ref("");
	const errors = ref({});
	const page = ref(1);
	const limit = 20;
	const suggestionList = ref(null);
	const mapRef = ref(null);
	const devices_data = ref([]);
	// RTO dropdown variables
	const rto_list = ref([]);
	const rto_id = ref("");
	const rto_search = ref("");
	const showRtoSuggestions = ref(false);
	const rtoSuggestionList = ref(null);
	
	// Dealer dropdown variables
	const dealer_search = ref("");
	const showDealerSuggestions = ref(false);
	const dealerSuggestionList = ref(null);

	const marker = ref({
		position: { lat: null, lng: null }
	});

	const center = ref({
		lat: null,
		lng: null
	});

	const current_place = ref(null);

	const mapOptions = {
		disableDefaultUI: true,
	};

	const handleGoBack = () => {
		const success = goBack(router);
		if (!success) {
			// If no history, go to dashboard as fallback
			router.push({ name: 'defaultRoot' });
		}
	};

	const restrictMobileInput = (event) => {
		// Remove any non-digit characters and limit to 10 digits
		const value = event.target.value.replace(/\D/g, '').slice(0, 10);
		mobile.value = value;
	};

	const job = ref({
		location: '',
		latitude: null,
		longitude: null
	});

	const geolocate = () => {
		navigator.geolocation.getCurrentPosition((position) => {
			marker.value.position = {
			lat: position.coords.latitude,
			lng: position.coords.longitude,
			};
			panToMarker();
		});
	};

	const panToMarker = () => {
		mapRef.value?.panTo(marker.value.position);
	};

	const handleMarkerDrag = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when marker is dragged
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
	};

	const handleMapClick = (e) => {
		marker.value.position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};
		// Update job coordinates when map is clicked
		job.value.latitude = e.latLng.lat();
		job.value.longitude = e.latLng.lng();
		console.log(e);
	};

	const setPlace = (place) => {
		current_place.value = place;
		if (current_place.value) {
			const lat = current_place.value.geometry.location.lat();
			const lng = current_place.value.geometry.location.lng();
			const markerPos = { lat, lng };

			center.value = markerPos;
			marker.value.position = markerPos;

			job.value.location = place.formatted_address;
			job.value.latitude = lat;
			job.value.longitude = lng;
		}
	};


	const handleScroll = () => {
		// Note: Pagination removed as it's not supported by the current API
		// If pagination is needed, it can be added to fetchAllDevicesForSearch
	};

	// Computed property for filtered RTO list
	const filteredRtoList = computed(() => {
		if (!rto_search.value || rto_search.value.trim() === '') {
			return rto_list.value;
		}
		const searchTerm = rto_search.value.toLowerCase();
		return rto_list.value.filter(rto => 
			rto.rto_code.toLowerCase().includes(searchTerm) || 
			rto.rto_name.toLowerCase().includes(searchTerm)
		);
	});

	// Computed property for filtered Dealer list
	const filteredDealerList = computed(() => {
		if (!dealer_search.value || dealer_search.value.trim() === '') {
			return dealers.value;
		}
		const searchTerm = dealer_search.value.toLowerCase();
		return dealers.value.filter(dealer => 
			dealer.first_name.toLowerCase().includes(searchTerm)
		);
	});

	// Filter company titles based on search
	const filterCompanyTitles = () => {
		if (!company_title_search.value.trim()) {
			filteredCompanyTitles.value = company_titles.value;
		} else {
			filteredCompanyTitles.value = company_titles.value.filter(company =>
				company.title.toLowerCase().includes(company_title_search.value.toLowerCase())
			);
		}
	};

	const fetchProducts = () => {

		get(routes.AllProducts, {}, false)
		.then((response) => {
			if (response.status === 200) {
				products.value = response.data.data;
				console.log(response.data.data);
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching products', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchAllDevices = (searchTerm = '') => {

		const params = {
			keyword: searchTerm,
		};

		get(routes.AllDevices, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				devices_data.value = response.data.data;
				console.log('All Devices Data:', response.data.data);
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchAllDevicesForSearch = () => {
		// Determine which search term to use based on product_id
		let searchTerm = '';
		if (product_id.value == 1 || product_id.value == '1') {
			searchTerm = device_imei.value;
		} else {
			searchTerm = vehicle_search.value;
		}

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.AllDevices, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log('All Devices Search Results:', response.data.data);
				// Store all devices with imei and vehicle_no
				devices.value = response.data.data || [];
				// Show suggestions if we have devices and input is focused
				if (devices.value.length > 0) {
					showSuggestions.value = true;
				}
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchDealers = () => {

		get(routes.getDealers, {}, false)
		.then((response) => {
			if (response.status === 200) {
				dealers.value = response.data.data;
				console.log('Dealers:', dealers.value);
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching dealers', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchCompanyTitles = () => {
		get(routes.getSpdCompanyTitles, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log('Company titles:', response.data.data);
				company_titles.value = response.data.data;
				filteredCompanyTitles.value = response.data.data;
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching company titles', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchDevices = () => {
		// Determine which search term to use based on product_id
		let searchTerm = '';
		if (product_id.value == 1 || product_id.value == '1') {
			searchTerm = device_imei.value;
		} else {
			searchTerm = vehicle_search.value;
		}

		// Don't fetch if no keyword is provided
		if (!searchTerm || searchTerm.trim() === '') {
			devices.value = [];
			showSuggestions.value = false;
			return;
		}

		const params = {
			keyword: searchTerm,
		};

		get(routes.searchJobData, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
				// Filter out devices with null IMEI only for product_id = 1
				if (product_id.value == 1 || product_id.value == '1') {
					devices.value = (response.data.data || []).filter(device => device.imei !== null && device.imei !== '');
				} else {
					devices.value = response.data.data || [];
				}
				// Show suggestions if we have devices and input is focused
				if (devices.value.length > 0) {
					showSuggestions.value = true;
				}

			} else {
				Swal.fire('Error', response.data.message || 'Error fetching devices', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchVehicleTypes = () => {

		get(routes.VehicleTypes, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
				vehicle_types.value = response.data.data;
			} else {
				Swal.fire('Error', response.data.message || 'Error fetching vehicle types', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const fetchRTOList = () => {

		get(routes.RTOList, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
				rto_list.value = response.data.data;
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('Validation Error', 'Please check your input data', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
			}
			else if (error.response?.status === 401) {
				Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
			}
		});
	};

	const setFile = (e, fieldName) => {
		const file = e.target.files[0];
		if (fieldName === 'rc_image') {
			rc_image.value = file;
		} else if (fieldName === 'device_image') {
			device_image.value = file;
		} else if (fieldName === 'vehicle_image') {
			vehicle_image.value = file;
		} else if (fieldName === 'captured_images') {
			captured_images.value = file;
		} else {
			rc_image.value = file; // Default fallback
		}
	};

	const generateCertificate = () => {
		
		errors.value = {};

		if ((product_id.value == 1 || product_id.value == '1') && (work_type.value == 1 || work_type.value == '1')) {
			if (!rc_image.value) {
				Swal.fire('Validation Error', 'RC Image is required for new work type', 'error');
				return;
			}
		}

		if (!rto_id.value) {
			Swal.fire('Validation Error', 'Please select an RTO', 'error');
			return;
		}

		// Validate speed governor for product_id = 3
		if (product_id.value == 3) {
			if (!sg_model.value || !sg_vehicle_model.value || !sg_cop_number.value) {
				Swal.fire('Validation Error', 'Please fill in all required speed governor fields (SG Model, SG Vehicle Model, and SG COP Number)', 'error');
				return;
			}
		}

		// Validate payment type
		if (!payment_type.value) {
			Swal.fire('Validation Error', 'Please select a payment type', 'error');
			return;
		}

		// Validate company title
		if (!selectedCompanyTitle.value) {
			Swal.fire('Validation Error', 'Please select a company title', 'error');
			return;
		}

		// Validate payment fields based on payment type
		if (payment_type.value == 1) {
			// Cash payment
			if (!cash_amount.value || parseFloat(cash_amount.value) <= 0) {
				Swal.fire('Validation Error', 'Please enter a valid cash amount', 'error');
				return;
			}
		} else if (payment_type.value == 2) {
			// Online payment
			if (!online_amount.value || parseFloat(online_amount.value) <= 0) {
				Swal.fire('Validation Error', 'Please enter a valid online amount', 'error');
				return;
			}
			if (!payment_id.value || payment_id.value.trim() === '') {
				Swal.fire('Validation Error', 'Please enter payment ID', 'error');
				return;
			}
		} else if (payment_type.value == 3) {
			// Both payment
			if (!cash_amount.value || parseFloat(cash_amount.value) <= 0) {
				Swal.fire('Validation Error', 'Please enter a valid cash amount', 'error');
				return;
			}
			if (!online_amount.value || parseFloat(online_amount.value) <= 0) {
				Swal.fire('Validation Error', 'Please enter a valid online amount', 'error');
				return;
			}
			if (!payment_id.value || payment_id.value.trim() === '') {
				Swal.fire('Validation Error', 'Please enter payment ID', 'error');
				return;
			}
		}

		// Set loading state
		isSubmitting.value = true;

		const formData = new FormData();
		formData.append('product_id', product_id.value);
		formData.append('work_type', work_type.value);
		formData.append('imei', device_imei.value || '');
		formData.append('customer_name', customer_name.value || '');
		formData.append('vehicle_no', vehicle_no.value);
		formData.append('vehicle_type', vehicle_type.value || '');
		formData.append('mobile', mobile.value);
		formData.append('date', date.value);
		formData.append('location', job.value.location);
		formData.append('latitude', job.value.latitude);
		formData.append('longitude', job.value.longitude);
		formData.append('dealer_id', dealer_id.value);
		formData.append('amount', amount.value);
		formData.append('rto_id', rto_id.value || '');
		formData.append('engine_no', engine_no.value || '');
		formData.append('chassis_no', chassis_no.value || '');
		formData.append('vehicle_make', vehicle_make.value || '');
		formData.append('vehicle_model', vehicle_model.value || '');
		formData.append('registration_date', registration_date.value || '');
		formData.append('payment_type', payment_type.value);
		if (selectedCompanyTitle.value) {
			formData.append('company_title_id', selectedCompanyTitle.value.id);
		}
		
		// Payment fields
		if (payment_type.value == 1 || payment_type.value == 3) {
			formData.append('cash_amount', cash_amount.value);
		}
		if (payment_type.value == 2 || payment_type.value == 3) {
			formData.append('online_amount', online_amount.value);
			formData.append('payment_id', payment_id.value);
		}
		
		// Product ID 2 fields (Camera)
		if (product_id.value == 2) {
			formData.append('camera_name', camera_name.value);
			formData.append('serial_number', serial_number.value);
			formData.append('camera_2', camera_2.value || '');
			formData.append('camera_3', camera_3.value || '');
			formData.append('camera_4', camera_4.value || '');
		}
		
		// Product ID 3 fields (Speed Governor)
		if (product_id.value == 3) {
			formData.append('sg_model', sg_model.value);
			formData.append('sg_vehicle_model', sg_vehicle_model.value);
			if (sg_test_report_no.value) {
				formData.append('sg_test_report_no', sg_test_report_no.value);
			}
			if (sg_tac_number.value) {
				formData.append('sg_tac_number', sg_tac_number.value);
			}
			formData.append('sg_cop_number', sg_cop_number.value);
		}
		
		// Image uploads
		if(rc_image.value){
			formData.append('rc_image', rc_image.value);
		}
		if(device_image.value){
			formData.append('device_image', device_image.value);
		}
		if(vehicle_image.value){
			formData.append('vehicle_image', vehicle_image.value);
		}
		if(product_id.value == 2 && captured_images.value){
			formData.append('captured_images', captured_images.value);
		}

		post(routes.assignSpdDeviceToDealer, formData, false)
			.then((response) => {
				if (response.status === 200) {
					Swal.fire('', response.data.message || 'Device certificate generated successfully', 'success');
					router.push({ name: 'job_management'});
				} else {
					isSubmitting.value = false;
					Swal.fire('', response.data.message || 'Failed to generate device certificate', 'error');
				}
			})
			.catch((error) => {
				isSubmitting.value = false;
				if (error.response?.status === 422) {
					errors.value = error.response.data.message;
					// Show first validation error in Swal
					const firstError = Object.values(error.response.data.message)[0];
					if (firstError && firstError[0]) {
						Swal.fire('Validation Error', firstError[0], 'error');
					}
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			});

	};

	const setImei = (device) => {
		// Use the device's vehicle_no to fill the vehicle_no field
		vehicle_no.value = device.vehicle_no || '';
		
		// For product_id != 1 (non-GPS), use data directly from old fetchDevices
		if (product_id.value != 1 && product_id.value != '1') {
			vehicle_search.value = device.vehicle_no || '';
			device_imei.value = ''; // Keep IMEI empty for non-product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			console.log('Non-GPS Device Data:', device);
		} else {
			// For product_id = 1 (GPS), use data directly from AllDevices API only
			device_imei.value = device.imei || '';
			vehicle_search.value = ''; // Keep vehicle_search empty for product-1
			mobile.value = device.mobile || '';
			device_id.value = device.id;
			console.log('GPS Device Data from AllDevices:', device);
		}
		
		showSuggestions.value = false;
	};

	// Clear IMEI field and reset related data
	const clearImeiField = () => {
		device_imei.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		showSuggestions.value = false;
		devices.value = [];
	};

	// Clear vehicle search field and reset related data
	const clearVehicleSearchField = () => {
		vehicle_search.value = '';
		vehicle_no.value = '';
		mobile.value = '';
		device_id.value = '';
		showSuggestions.value = false;
		devices.value = [];
	};

	// Watch for changes in device_imei to handle clearing
	const watchDeviceImei = () => {
		if (!device_imei.value || device_imei.value.trim() === '') {
			clearImeiField();
		}
	};

	// Watch for changes in vehicle_search to handle clearing
	const watchVehicleSearch = () => {
		if (!vehicle_search.value || vehicle_search.value.trim() === '') {
			clearVehicleSearchField();
		}
	};

	// Handle IMEI input with debounced search and clear functionality
	const handleImeiInput = () => {
		watchDeviceImei();
		if (device_imei.value && device_imei.value.trim() !== '') {
			// Use fetchAllDevices for the search
			fetchAllDevicesDebounced();
		}
	};

	// Handle vehicle search input with debounced search and clear functionality
	const handleVehicleSearchInput = () => {
		watchVehicleSearch();
		if (vehicle_search.value && vehicle_search.value.trim() !== '') {
			// Use the old fetchDevices for non-GPS products
			fetchDevicesDebounced();
		}
	};

	// Handle input blur with delay to allow for selection
	const handleInputBlur = () => {
		setTimeout(() => {
			showSuggestions.value = false;
		}, 200);
	};

	// Add click outside functionality
	const handleClickOutside = (event) => {
		const inputElement = event.target.closest('.form-control');
		const suggestionElement = event.target.closest('.list-group');
		const dropdownElement = event.target.closest('.speed-governor-dropdown');
		
		if (!inputElement && !suggestionElement && !dropdownElement) {
			showSuggestions.value = false;
			showRtoSuggestions.value = false;
			showDealerSuggestions.value = false;
			showCompanyTitleSuggestions.value = false;
			showSpeedGovernorDropdown.value = false;
		}
	};

	// Fetch speed governors (lazy loading)
	const fetchSpeedGovernors = () => {
		if (speedGovernors.value.length > 0) {
			// Data already loaded
			return;
		}

		isLoadingSpeedGovernors.value = true;
		get(routes.getSpeedGovernorData, {}, false)
			.then((response) => {
				if (response.status === 200) {
					console.log('Speed governors API response:', response.data);
					console.log('Speed governors data:', response.data.data);
					
					// Handle different possible response structures
					let data = response.data.data;
					if (Array.isArray(data)) {
						speedGovernors.value = data;
						filteredSpeedGovernors.value = data;
					} else if (data && Array.isArray(data.data)) {
						speedGovernors.value = data.data;
						filteredSpeedGovernors.value = data.data;
					} else if (data && Array.isArray(data.speedGovernors)) {
						// Handle the actual API response structure
						speedGovernors.value = data.speedGovernors;
						filteredSpeedGovernors.value = data.speedGovernors;
					} else {
						console.error('Unexpected data structure:', data);
						speedGovernors.value = [];
						filteredSpeedGovernors.value = [];
					}
				} else {
					Swal.fire('Error', response.data.message || 'Error fetching speed governors', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('Validation Error', 'Please check your input data', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
				}
			})
			.finally(() => {
				isLoadingSpeedGovernors.value = false;
			});
	};

	// Handle speed governor input click/focus
	const handleSpeedGovernorClick = () => {
		showSpeedGovernorDropdown.value = true;
		fetchSpeedGovernors(); // Load data only when clicked
	};

	// Filter speed governors based on search
	const filterSpeedGovernors = () => {
		// Don't filter if data hasn't loaded yet
		if (isLoadingSpeedGovernors.value) {
			return;
		}

		// Check if speedGovernors is an array and has data
		if (!Array.isArray(speedGovernors.value) || speedGovernors.value.length === 0) {
			filteredSpeedGovernors.value = [];
			return;
		}

		if (!speedGovernorSearch.value.trim()) {
			filteredSpeedGovernors.value = speedGovernors.value;
			return;
		}

		const searchTerm = speedGovernorSearch.value.toLowerCase();
		filteredSpeedGovernors.value = speedGovernors.value.filter(sg => {
			const vehicleModel = sg.vehicle_model?.toLowerCase() || '';
			const sgModel = sg.sg_model?.toLowerCase() || '';
			return vehicleModel.includes(searchTerm) || sgModel.includes(searchTerm);
		});
	};

	// Select speed governor
	const selectSpeedGovernor = (sg) => {
		selectedSpeedGovernor.value = sg;
		speedGovernorSearch.value = sg.sg_model ? `${sg.vehicle_model} - ${sg.sg_model}` : sg.vehicle_model;
		showSpeedGovernorDropdown.value = false;
		
		// Populate fields from selected speed governor
		sg_model.value = sg.sg_model || '';
		sg_vehicle_model.value = sg.vehicle_model || '';
		sg_test_report_no.value = sg.test_report_no || '';
		sg_tac_number.value = sg.sg_tac_number || '';
		sg_cop_number.value = sg.cop_number || '';
		
		// If TAC or COP are not in the main object, fetch details
		if (!sg.sg_tac_number || !sg.cop_number) {
			fetchSpeedGovernorDetails(sg.id);
		}
	};

	// Fetch speed governor details
	const fetchSpeedGovernorDetails = (sgId) => {
		const params = {
			id: sgId
		};

		get(routes.speedGovernorDetails, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					console.log('Speed governor details:', response.data.data);
					const details = response.data.data;
					
					// Update test report number if it was empty
					if (!sg_test_report_no.value && details.test_report_no) {
						sg_test_report_no.value = details.test_report_no;
					}
					// Update TAC and COP number fields if they were empty
					if (!sg_tac_number.value && details.sg_tac_number) {
						sg_tac_number.value = details.sg_tac_number;
					}
					if (!sg_cop_number.value && details.cop_number) {
						sg_cop_number.value = details.cop_number;
					}
				} else {
					console.error('Failed to fetch speed governor details:', response.data.message);
				}
			})
			.catch((error) => {
				console.error('Error fetching speed governor details:', error);
				if (error.response?.status === 401) {
					Swal.fire('Unauthorized', 'Please login again', 'error');
					router.push({ name: 'login' });
				}
			});
	};

	// Clear speed governor fields when product_id changes
	const clearSpeedGovernorFields = () => {
		selectedSpeedGovernor.value = null;
		speedGovernorSearch.value = '';
		showSpeedGovernorDropdown.value = false;
		sg_model.value = '';
		sg_vehicle_model.value = '';
		sg_test_report_no.value = '';
		sg_tac_number.value = '';
		sg_cop_number.value = '';
	};

	// Watch for product_id changes to clear speed governor fields
	watch(() => product_id.value, (newVal, oldVal) => {
		if (oldVal && oldVal != newVal && oldVal == 3) {
			clearSpeedGovernorFields();
		}
	});

	onMounted(() => {
		fetchProducts();
		fetchDealers();
		fetchVehicleTypes();
		fetchRTOList();
		fetchCompanyTitles();

		// Add click outside listener
		document.addEventListener('click', handleClickOutside);
	});

	onUnmounted(() => {
		// Remove click outside listener
		document.removeEventListener('click', handleClickOutside);
	});

	// RTO dropdown handlers
	const handleRtoSearch = () => {
		if (rto_search.value && rto_search.value.trim() !== '') {
			showRtoSuggestions.value = true;
		} else {
			showRtoSuggestions.value = false;
			// Clear RTO ID if search is cleared
			if (!rto_search.value || rto_search.value.trim() === '') {
				rto_id.value = '';
			}
		}
	};

	const handleRtoInputBlur = () => {
		setTimeout(() => {
			showRtoSuggestions.value = false;
		}, 200);
	};

	const setRto = (rto) => {
		rto_search.value = `${rto.rto_code} - ${rto.rto_name}`;
		rto_id.value = rto.id;
		showRtoSuggestions.value = false;
	};

	// Clear RTO field
	const clearRtoField = () => {
		rto_search.value = '';
		rto_id.value = '';
		showRtoSuggestions.value = false;
	};

	// Dealer dropdown handlers
	const handleDealerSearch = () => {
		if (dealer_search.value && dealer_search.value.trim() !== '') {
			showDealerSuggestions.value = true;
		} else {
			showDealerSuggestions.value = false;
			// Clear Dealer ID if search is cleared
			if (!dealer_search.value || dealer_search.value.trim() === '') {
				dealer_id.value = '';
			}
		}
	};

	const handleDealerInputBlur = () => {
		setTimeout(() => {
			showDealerSuggestions.value = false;
		}, 200);
	};

	const setDealer = (dealer) => {
		dealer_search.value = dealer.first_name;
		dealer_id.value = dealer.id;
		showDealerSuggestions.value = false;
	};

	// Clear Dealer field
	const clearDealerField = () => {
		dealer_search.value = '';
		dealer_id.value = '';
		showDealerSuggestions.value = false;
	};

	// Company Title dropdown handlers
	const handleCompanyTitleSearch = () => {
		filterCompanyTitles();
		if (company_title_search.value && company_title_search.value.trim() !== '') {
			showCompanyTitleSuggestions.value = true;
		} else {
			showCompanyTitleSuggestions.value = false;
			// Clear Company Title if search is cleared
			if (!company_title_search.value || company_title_search.value.trim() === '') {
				selectedCompanyTitle.value = null;
			}
		}
	};

	const handleCompanyTitleInputBlur = () => {
		setTimeout(() => {
			showCompanyTitleSuggestions.value = false;
		}, 200);
	};

	const setCompanyTitle = (companyTitle) => {
		selectedCompanyTitle.value = companyTitle;
		company_title_search.value = companyTitle.title;
		showCompanyTitleSuggestions.value = false;
	};

	// Payment type change handler
	const onPaymentTypeChange = () => {
		if (payment_type.value == 1) {
			// Cash payment - pre-fill cash amount with total amount
			cash_amount.value = amount.value || '';
			online_amount.value = '';
			payment_id.value = '';
		} else if (payment_type.value == 2) {
			// Online payment - clear cash amount
			cash_amount.value = '';
			online_amount.value = amount.value || '';
			payment_id.value = '';
		} else if (payment_type.value == 3) {
			// Both payment - clear both amounts initially
			cash_amount.value = '';
			online_amount.value = '';
			payment_id.value = '';
		} else {
			// Reset all payment fields when type is cleared
			payment_id.value = '';
			online_amount.value = '';
			cash_amount.value = '';
		}
	};


</script>